import styled from "styled-components";
import { secondary, borderDark } from "@/static/styled/custom.styled";
import { ModalContainer } from "@c/common/GlobalModal";

// bottom space keeps the pager clear of the fixed plus button
export const Wrapper = styled.div`
  padding: 24px 24px 90px 24px;
`;

export const PopUpContainer = ModalContainer.extend`
  top: 0;
`;

export const PopUpBody = styled.div`
  width: 640px;
  max-width: 100%;
  padding: 24px 28px;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

export const FieldLabel = styled.div`
  width: 130px;
  flex-shrink: 0;
  font-weight: 500;
`;

export const FieldControl = styled.div`
  flex: 1;
  max-width: 520px;
  display: flex;
  align-items: center;
`;

export const SelectHolder = styled.div`
  flex: 1;
  min-width: 240px;
`;

export const LinkButton = styled.button`
  border: none;
  background: none;
  padding: 0 0 0 12px;
  color: ${(props) => (props.danger ? "#d63031" : secondary)};
  font-size: 14px;
  cursor: pointer;
  outline: none;
  white-space: nowrap;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CheckLabel = styled.label`
  margin: 0 24px 0 0;
  cursor: pointer;
  input {
    margin-right: 6px;
  }
`;

export const HelperText = styled.p`
  margin: 12px 0 0 0;
  font-size: 13px;
  color: #777;
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const FilterHolder = styled.div`
  width: 320px;
`;

export const RecordsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 8px 10px;
    border-bottom: 1px solid ${borderDark};
    text-align: left;
    font-size: 14px;
  }
  th {
    font-weight: 600;
    background: #faf8f5;
  }
`;

export const OtpEditInput = styled.input`
  width: 80px;
  border-radius: 100px;
  border: 1px solid ${borderDark};
  padding: 0 10px;
  text-align: center;
  outline: none;
`;

export const Pager = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  font-size: 14px;
  span {
    margin: 0 4px 0 16px;
  }
`;

export const EmptyText = styled.p`
  margin: 16px 0 0 0;
  text-align: center;
  color: #777;
`;
